import he from 'he'

/**
 * base normlier
 */
export const mapKeyIfExist = (origKey, newKey = '') => (object) => {
  if (typeof object !== 'undefined' && (typeof object[origKey]) !== 'undefined') {
    const key = (newKey === '') ? origKey : newKey
    return {
      [key]: object[origKey]
    }
  }

  return {}
}

export const transformKey = (origKey, newKey, defaultValue) => (object) => {
  if (typeof defaultValue === 'undefined') { throw new Error('defaultValue is required') }
  return {
    [newKey]:
    (typeof object[origKey]) === 'undefined' ? defaultValue : object[origKey]
  }
}

export const transformRequiredKey = (origKey, newKey, transform) => (object) => {
  if (typeof object === 'undefined') { throw new Error('object going to transform is undefined' + ` ${origKey}`) }
  if (typeof object[origKey] === 'undefined') { throw new Error(`${origKey} is required`) }
  if (typeof transform === 'function') {
    return { [newKey]: transform(object[origKey]) }
  }
  return { [newKey]: object[origKey] }
}

export const unescapeEntity = (value) => {
  if (!value) {
    return
  }
  return he.decode(value)
}
